import React, { useState } from "react";
import { DatePicker, Space } from "antd";
import { connect } from "react-redux";
import {
  getStats,
  getUserDashBoardData,
  setEndDate,
  setStartDate,
} from "actions/userManagement";
import PageDataLoader from "components/pageDataLoader";
import moment from "moment";
const { RangePicker } = DatePicker;

const CalenderPopup = ({
  setStartDate,
  getDashBoardData,
  setEndDate,
  barGraphPlotFunction,
  togglePageLoader,
  getStats,
  dashBoardRole,
  getUserDashBoardData,
  isMonthOrWeek,
}) => {
  const [pageLoader, setPageLoader] = useState(false);
  const [hackValue, setHackValue] = useState(null);

  function onChange(dates, dateStrings) {
    setHackValue(null);
    if (dates && dates[0] && dates[1] && isMonthOrWeek === 'week') {
      if (dates[1].diff(dates[0], 'days') + 1 > 7) return;
    }
    setStartDate(moment(dateStrings[0],'DD-MM-YYYY').format('YYYY-MM-DD'));
    setEndDate(moment(dateStrings[1],'DD-MM-YYYY').format('YYYY-MM-DD'));
    if (dashBoardRole) {
      setPageLoader(true);
      getUserDashBoardData(() => setPageLoader(false));
    } else {
      setPageLoader(true);
      getStats(() => setPageLoader(false));
    }
  }

  const disabledDate = (current) => {
    if (isMonthOrWeek === 'week' && hackValue && hackValue[0]) {
      return current.diff(hackValue[0], 'days') > 6 || hackValue[0].diff(current, 'days') > 6;
    }
    return false;
  };

  const onCalendarChange = (val) => setHackValue(val);
  const onOpenChange = (open) => { if (open) setHackValue([null, null]); else setHackValue(null); };

  return (
    <div className="rangePicker">
      <Space
        direction="vertical"
        mode={"month"}
        size={12}
        style={{ width: "240px", marginLeft: "-5px" }}
      >
        <RangePicker
          dropdownClassName={"rangePickerB"}
          placeholder={["Start Date", "End Date"]}
          onChange={onChange}
          onCalendarChange={onCalendarChange}
          onOpenChange={onOpenChange}
          disabledDate={disabledDate}
          renderExtraFooter={() => "extra footer"}
          showTime
          format={"DD-MM-YYYY"}
          getPopupContainer={(trigger) => trigger.parentElement}
        />
      </Space>
      <PageDataLoader visible={pageLoader} />
    </div>
  );
};
const mapStateToProps = (state) => {
  const { tab, dashBoardRole, isMonthOrWeek } = state.userManagement;
  return {
    tab,
    dashBoardRole,
    isMonthOrWeek,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setStartDate: (m) => dispatch(setStartDate(m)),
  setEndDate: (m) => dispatch(setEndDate(m)),
  getStats: (callback) => dispatch(getStats(callback)),
  getUserDashBoardData: (callback) => dispatch(getUserDashBoardData(callback)),
  //   getDashBoardData: (callback) => dispatch(getDashBoardData(callback))
});

export default connect(mapStateToProps, mapDispatchToProps)(CalenderPopup);
